import React from 'react';
import './LoadingPage.css';
import { CDBSpinner } from 'cdbreact';
import { Card } from 'react-bootstrap';

export const LoadingPage = () => {

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				width: '100%',
				maxHeight: '100vh',
				overflowY: 'scroll',
				justifyContent: 'center',
			}}
		>
			<Card>
				<Card.Body
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
						alignContent: 'center',
					}}
				>
					<CDBSpinner />
					<br />
					<h2 className='text'>Cargando, Por favor espere...</h2>
				</Card.Body>
			</Card>
		</div>
	);
};
